import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { switchClinic, switchClinicResponse } from 'Redux/Clinic/clinic.actions'
import {
  apiStatus,
  getuserData,
  loginResponse,
} from 'Redux/Login/login.actions'
import { loginInfo } from 'Redux/PriorAuth/PriorAuthApis/prior.actions'

function SwitchClinic(props) {
  const { setSelectedClinic, selectedClinic, clinics, setOpenedPopover } = props
  const history = useHistory()
  // handle clinic change
  const handleClinicChange = (event) => {
    const clinicId = event.target.value
    setSelectedClinic(clinicId)
    localStorage.setItem('clinicSwitchId', clinicId) // store selected clinic
    // window.location.href = '/switch-clinic'
    history.push('/switch-clinic')
    // setInterval(() => {}, 0)
  }

  return (
    <>
      {localStorage.getItem('isInternalUser') == 1 ? (
        <FormControl size="small" fullWidth>
          <InputLabel id="clinic-switch-label">Switch Clinic</InputLabel>
          <Select
            labelId="clinic-switch-label"
            value={selectedClinic}
            label="Switch Clinic"
            onChange={handleClinicChange}
            style={{ minWidth: '200px' }}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 300,
                  width: 400,
                  overflowY: 'auto',
                },
              },
            }}
          >
            {clinics?.sort((a,b)=>a.name.localeCompare(b.name))?.map((clinic) => (
              <MenuItem key={clinic?.clinicId} value={clinic?.clinicId}>
                {clinic?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <div className="clinicHeader__popover--name">
          {JSON.parse(localStorage.getItem('user_data'))?.clinicName}
        </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  clinicData: state.clinic,
  priorAuthData: state.priorAuth,
})

const mapDispatchToProps = (dispatch) => ({
  switchClinic: (clinicID) => dispatch(switchClinic(clinicID)),
  switchClinicResponse: (values) => dispatch(switchClinicResponse(values)),
  apiStatus: (values) => dispatch(apiStatus(values)),
  getuserData: (values) => dispatch(getuserData(values)),
  loginResponse: (values) => dispatch(loginResponse(values)),
  loginInfo: (values) => dispatch(loginInfo(values)),
})
SwitchClinic.propTypes = {
  switchClinic: PropTypes.func,
  apiStatus: PropTypes.func,
  getuserData: PropTypes.func,
  loginResponse: PropTypes.func,
  loginInfo: PropTypes.func,
  setSelectedClinic: PropTypes.func,
}
export default connect(mapStateToProps, mapDispatchToProps)(SwitchClinic)
